import { css } from '@emotion/react'
import { Link } from 'react-router-dom'

import Avatar from 'react-avatar'
import { Auth0User } from '../../../types'
import { Menu } from '../../shared/menu'
import { Thumbnail } from '../../shared/media'
import { baseColor } from '../../../lib/styles/colors'
import useAppSettings from '../../../lib/hooks/useAppSettings'
import RoleSwitcher from '../RoleSwitcher'

export type TopNavMenuProps = {
  onLogout: (logoutOptions?: any) => void
  user: Auth0User | undefined
}

const topNavMenuCss = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;

  button {
    color: ${baseColor};
  }
`

/** IMPORTANT:  This code is duplicated in scheduler.
 * Verify any changes here are also made in scheduler.
 */
export const TopNavMenu = ({ onLogout, user }: TopNavMenuProps) => {
  const { homeSettings } = useAppSettings()
  const { signoutText } = homeSettings

  const handleLogout = async () => {
    // Keycloak at the momento does not have federated logout
    onLogout()
  }

  const menuItems = [
    {
      text: signoutText,
      disabled: false,
      onClick: handleLogout
    }
  ]
  if (!user) {
    return null
  }

  const styleAvatar = {
    fontSize: '16px',
    letterSpacing: '0.5px',
    lineHeight: '20px',
    fontFamily: 'Roboto'
  }

  const fullName =
    user && user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : ''

  const profileLinkLabel = fullName || user?.email || 'User profile'

  // WCAG 2.5.3 - Label in Name: Include visible initials in accessible name
  const initials = fullName
    ? fullName
        .split(' ')
        .map((n) => n[0])
        .join('')
    : 'User'
  const accessibleLabel = `${initials} - View profile for ${profileLinkLabel}`

  return (
    <span css={topNavMenuCss}>
      <RoleSwitcher />
      <Link to="/profile" aria-label={accessibleLabel}>
        {user && user.picture ? (
          <Thumbnail alt="Profile" src={user?.picture} />
        ) : (
          <Avatar style={styleAvatar} size="40" round name={fullName || 'User'} />
        )}
      </Link>
      <Menu
        ariaLabel="Top Navigation Menu"
        displayTooltip={false}
        icon="Arrow"
        id="gravatar-menu"
        menuItems={menuItems}
      />
    </span>
  )
}

export default TopNavMenu
